import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AppToastContainer() {
  return <ToastContainer />;
}

export default AppToastContainer;
